<template>
  <div v-if="receta" class="receta-detalle-overlay" @click.self="$emit('cerrar')">
    <div class="receta-detalle-panel shadow" role="dialog" aria-modal="true" :aria-labelledby="tituloId">
      <div class="d-flex justify-content-between align-items-start gap-2 mb-3">
        <div>
          <span class="badge rounded-pill bg-success mb-2">Mía</span>
          <h3 :id="tituloId" class="h5 mb-1">{{ receta.titulo }}</h3>
          <p class="text-muted small mb-0">
            <span v-if="receta.tipo">{{ etiquetaTipo(receta.tipo) }}</span>
            <span v-if="receta.raciones"> · {{ receta.raciones }} {{ receta.raciones === 1 ? 'ración' : 'raciones' }}</span>
            <span v-if="receta.tiempo_min"> · {{ receta.tiempo_min }} min</span>
          </p>
        </div>
        <button type="button" class="btn-close" aria-label="Cerrar" @click="$emit('cerrar')"></button>
      </div>

      <div v-if="receta.notas" class="alert alert-light border small">{{ receta.notas }}</div>

      <h4 class="h6 text-uppercase text-muted">Ingredientes</h4>
      <ul class="mb-4">
        <li v-for="(ing, i) in receta.ingredientes" :key="`ing-${i}`">{{ ing }}</li>
      </ul>

      <h4 class="h6 text-uppercase text-muted">Preparación</h4>
      <ol class="mb-4">
        <li v-for="(paso, i) in receta.pasos" :key="`paso-${i}`" class="mb-2">{{ paso }}</li>
      </ol>

      <div class="d-flex justify-content-between flex-wrap gap-2">
        <button type="button" class="btn btn-outline-danger btn-sm" :disabled="eliminando" @click="eliminar">
          <span v-if="eliminando" class="spinner-border spinner-border-sm me-1"></span>
          <i v-else class="bi bi-trash me-1"></i>
          Eliminar
        </button>
        <button type="button" class="btn btn-outline-secondary btn-sm" @click="$emit('cerrar')">Cerrar</button>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref } from 'vue';
import axios from '../config/axios';
import { etiquetaTipo } from '../utils/recetasForm';

export default {
  name: 'RecetaDetalle',
  props: {
    receta: { type: Object, default: null },
  },
  emits: ['cerrar', 'eliminada'],
  setup(props, { emit }) {
    const eliminando = ref(false);
    const tituloId = computed(() => `receta-detalle-${props.receta?.id || 'x'}`);

    const eliminar = async () => {
      if (!props.receta?.id) return;
      if (!window.confirm(`¿Eliminar «${props.receta.titulo}»?`)) return;
      eliminando.value = true;
      try {
        await axios.delete(`/api/recetas/usuario/${props.receta.id}`);
        emit('eliminada', props.receta.id);
        emit('cerrar');
      } catch (err) {
        window.alert(err.response?.data?.error || 'No se pudo eliminar la receta');
      } finally {
        eliminando.value = false;
      }
    };

    return {
      eliminando,
      tituloId,
      etiquetaTipo,
      eliminar,
    };
  },
};
</script>

<style scoped>
.receta-detalle-overlay {
  position: fixed;
  inset: 0;
  z-index: 1050;
  background: rgba(15, 23, 15, 0.45);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 1.5rem 1rem;
  overflow-y: auto;
}

.receta-detalle-panel {
  background: #fff;
  border-radius: 0.75rem;
  width: min(720px, 100%);
  padding: 1.5rem;
  margin: auto;
}
</style>
